module.exports = __webpack_public_path__ + "img/end_location.160eaf3b.svg";